import React, { useState, useEffect } from "react";
import {
	useTable,
	usePagination,
	useSortBy,
	useExpanded,
	useGlobalFilter,
} from "react-table";
import { Form, Button } from "react-bootstrap";
import { DEPARTURE_REPORT_DATA_COLUMNS } from "../../columns/departureReportColumns";
// import MainTablePagination from "./MainTablePagination";
import { getContainerMasterData } from "../../../services/ContainerMasterService";
import { FormatDepartureReportData } from "../../../utils/dataFilter";
import moment from "moment";
import { exportData } from "../../../utils/helpers";
import { toast } from "react-toastify";
import Loader from "../../Loader";
import {
	updateContainerData,
	updateAggregateContainerData,
	updateFiveMContainerData,
} from "../../../services/ContainerMasterService";
import store from "../../../store/Store";
import { dispatcher } from "../../../store/storeHelpers";
import * as actionTypes from "../../../store/ActionTypes";
import { getUser } from "../../../services/authService";
import InvoicePackagingUploadModal from "../InvoicePackagingUploadModal";
import InvoicePackagingPDFViewer from "../InvoicePackagingPDFViewer";
import { defaultDepartureReportColumn } from "../cells/editable/DepartureReportEditableCell";
import { filter } from "lodash";
import DepartureReportActionCenter from "../action-center/DepartureReportActionCenter";
import MainTablePaginationAdv from "./MainTablePaginationAdv";

function DepartureReportTable({
	setGetOutCounterData,
	filteredUserAccessData,
}) {
	const user = getUser();
	// const [columns] = useState(DISCHARGEREPORT_DATA_COLUMNS);
	const [date, setDate] = useState(moment().format("YYYY-MM-DD"));
	const [tableData, setTableData] = useState([]);
	const [loading, setLoading] = useState(false);
	const [showUploadModal, setShowUploadModal] = useState(null);
	const [showViewModal, setShowViewModal] = useState(null);

	var allowToEdit = filter(filteredUserAccessData, { Edit: 1 }).length > 0;
	var allowToAdd = filter(filteredUserAccessData, { Add: 1 }).length > 0;
	var allowToUpload = filter(filteredUserAccessData, { Upload: 1 }).length > 0;

	const updateCellDataForFactoryIn = (
		rowIndex,
		columnId,
		dateValue,
		timeValue
	) => {
		setTableData((old) =>
			old.map((row, index) => {
				if (index === rowIndex) {
					return {
						...old[rowIndex],
						[columnId]: `${dateValue}T${timeValue}`,
					};
				}
				return row;
			})
		);
	};

	useEffect(() => {
		const unsubscribe = store.subscribe(() => {
			setTableData(
				Object.values(store.getState().daily_container_discharge_report)
			);
		});
		return () => {
			unsubscribe();
		};
	});

	useEffect(() => {
		async function getData() {
			var filteredResponse = [];
			try {
				setLoading(true);
				const response = await getContainerMasterData(date);
				for (let i = 0; i < response.data.length; i++) {
					if (response.data[i].Gate_In_Date) {
						filteredResponse.push(response.data[i]);
					}
				}
				if (filteredResponse.length === 0) {
					toast.error("Data not found.");
				}
				dispatcher(
					actionTypes.DISCHARGE_REPORT_LOAD,
					FormatDepartureReportData(filteredResponse)
				);
				// setTableData(FormatArrivalReportData(filteredResponse))
				setLoading(false);
			} catch (error) {
				setTableData([]);
				setLoading(false);
				toast.error("Data not found.");
			}
		}
		getData();
	}, [date]);

	useEffect(() => {
		var gateOutDataForCount = [];
		for (let i = 0; i < tableData.length; i++) {
			if (tableData[i]["Gate_Out_Date"]) {
				gateOutDataForCount.push({
					...tableData[i],
				});
			}
		}
		setGetOutCounterData({
			GateOut: gateOutDataForCount,
			TotalGateOut: tableData,
		});
	}, [setGetOutCounterData, tableData]);

	const {
		getTableProps,
		getTableBodyProps,
		headerGroups,
		page,
		nextPage,
		previousPage,
		canNextPage,
		pageOptions,
		pageCount,
		gotoPage,
		state,
		setPageSize,
		canPreviousPage,
		setGlobalFilter,
		prepareRow,
		allColumns,
		getToggleHideAllColumnsProps,
	} = useTable(
		{
			columns: DEPARTURE_REPORT_DATA_COLUMNS,
			data: tableData,
			defaultColumn: defaultDepartureReportColumn,
			autoResetPage: false,
			initialState: { pageSize: 50 },
			autoResetExpanded: false,
			autoResetGlobalFilter: false,
			updateCellDataForFactoryIn,
			allowToEdit,
		},
		useGlobalFilter,
		useSortBy,
		useExpanded,
		usePagination
	);

	const { pageIndex, pageSize, globalFilter } = state;
	const dataExportHandler = () => {
		var is_Gate_Out_DatePresent = [];
		for (let i = 0; i < tableData.length; i++) {
			if (tableData[i]["Gate_Out_Date"]) {
				is_Gate_Out_DatePresent.push({
					...tableData[i],
				});
			}
		}
		exportData(
			is_Gate_Out_DatePresent.map((item) => {
				return {
					Date: item["Date"] === "Invalid date" ? "" : item["Date"],
					Module: item["DataOf"],
					Factory_In_Date_Time:
						item["Gate_In_Date"] === "Invalid date"
							? ""
							: moment(item["Gate_In_Date"]).format("DD-MM-YYYY HH:mm A"),
					Factory_Out_Date_Time:
						item["Gate_Out_Date"] === "Invalid date"
							? ""
							: moment(item["Gate_Out_Date"]).format("DD-MM-YYYY HH:mm A"),
					Container_No: item["Container_Number"],
					Seal_No: item["Seal_No"],
					LR_No: item["LR_NO"],
					Vehicle_No: item["Vehicle_No"],
					Carrier: item["Carrier"],
					Clearence: item["Clearence"],
					Dest_Country: item["Dest_Country"],
					Dest_Port: item["Dest_Port"],
					Final_Destination: item["final_destination"],
					Product: item["Product"],
					Booking_No: item["Booking_Number"],
					Transporter: item["Transporter"],
					Pick_Up_Location: item["pick_up_location"],
					SAP_code: item["SAP_code"],
					Container_Type: item["Container_Type"],
					Driver_No: item["Driver_No"],
					Remark: item["Remarks"],
				};
			}),
			`Departure Report ${moment(date).format("DD/MM/YYYY")}`
		);
	};

	async function actionClickHandlerForDischarge(cell) {
		try {
			if (cell.row.original.DataOf === "TRACTOR") {
				updateContainerData({
					Id: `${cell.row.original["ContainerMasterId"]}`,
					columnName: "Gate_Out_Date",
					prevVal: "-",
					value: moment().format("YYYY-MM-DD HH:mm:ss"),
					UserId: user.uid,
				});
				dispatcher(actionTypes.DISCHARGE_REPORT_GATE_OUT, {
					Id: `${cell.row.original["ContainerMasterId"]}`,
					columnName: "Gate_Out_Date",
					prevVal: "-",
					value: moment().format("YYYY-MM-DD  HH:mm:ss"),
					UserId: user.uid,
				});
			}
			if (cell.row.original.DataOf === "AGGREGATE") {
				updateAggregateContainerData({
					Id: `${cell.row.original["ContainerMasterId"]}`,
					columnName: "Gate_Out_Date",
					prevVal: "-",
					value: moment().format("YYYY-MM-DD HH:mm:ss"),
					UserId: user.uid,
				});
				dispatcher(actionTypes.DISCHARGE_REPORT_GATE_OUT, {
					Id: `${cell.row.original["ContainerMasterId"]}`,
					columnName: "Gate_Out_Date",
					prevVal: "-",
					value: moment().format("YYYY-MM-DD  HH:mm:ss"),
					UserId: user.uid,
				});
			}
			if (cell.row.original.DataOf === "5M") {
				updateFiveMContainerData({
					Id: `${cell.row.original["ContainerMasterId"]}`,
					columnName: "Gate_Out_Date",
					prevVal: "-",
					value: moment().format("YYYY-MM-DD HH:mm:ss"),
					UserId: user.uid,
				});
				dispatcher(actionTypes.DISCHARGE_REPORT_GATE_OUT, {
					Id: `${cell.row.original["ContainerMasterId"]}`,
					columnName: "Gate_Out_Date",
					prevVal: "-",
					value: moment().format("YYYY-MM-DD  HH:mm:ss"),
					UserId: user.uid,
				});
			}
			toast.success(
				`"Factory Out Date & Time" column updated with "${moment().format(
					"DD-MM-YYYY HH:mm"
				)}"`
			);
		} catch (error) {}
	}

	const cellRenderHandler = (cell) => {
		if (cell.column.id === "Gate_Out_Date") return "action";
		if (cell.column.id === "upload_doc") return "upload";
		if (cell.column.id === "view_doc") return "view";
		return "data";
	};

	function uploadModalClickhandler(cell) {
		setShowUploadModal(cell);
	}
	function viewModalClickhandler(cell) {
		setShowViewModal(cell);
	}
	return (
		<>
			{loading && <Loader />}
			<div className="table_actions d-flex">
				<Form.Group>
					<Form.Control
						value={globalFilter || ""}
						onChange={(e) => setGlobalFilter(e.target.value)}
						className="hiden-inp"
						placeholder="search here.."
					/>
				</Form.Group>
				<DepartureReportActionCenter
					date={date}
					setDate={setDate}
					dataExportHandler={dataExportHandler}
					tableData={tableData}
					allColumns={allColumns}
					getToggleHideAllColumnsProps={getToggleHideAllColumnsProps}
					type={"Daily"}
					filteredUserAccessData={filteredUserAccessData}
				/>
			</div>
			<div className="table_container">
				<table {...getTableProps()} className="table mtbs">
					<thead>
						{headerGroups.map((headerGroup) => (
							<tr {...headerGroup.getHeaderGroupProps()}>
								{headerGroup.headers.map((column) => (
									<th {...column.getHeaderProps(column.getSortByToggleProps())}>
										{column.render("Header")}
										<i
											className={
												column.isSorted
													? column.isSortedDesc
														? "fi fi-rr-angle-small-down head-icon"
														: "fi fi-rr-angle-small-up head-icon"
													: "fi fi-rr-circle-small head-icon w"
											}
										></i>
									</th>
								))}
							</tr>
						))}
					</thead>
					<tbody {...getTableBodyProps()}>
						{page.map((row) => {
							prepareRow(row);
							return (
								<tr {...row.getRowProps()}>
									{row.cells.map((cell) => {
										return (
											<td
												{...cell.getCellProps()}
												className={
													cell.row.subRows.length !== 0 ? "main-row" : "sub-row"
												}
											>
												<div className="cell-wrap">
													<span>
														{(cellRenderHandler(cell) === "data" ||
															cell.column.id === "Gate_Out_Date") &&
															cell.render("Cell")}
													</span>
													{cellRenderHandler(cell) === "action" && (
														<Button
															className="btn btn-sm btn-tbl gateOutBtn"
															style={{
																height: "35px",
																position: "relative",
																left: "0px",
															}}
															onClick={() =>
																actionClickHandlerForDischarge(cell)
															}
															disabled={
																cell.row.original.Gate_Out_Date || !allowToAdd
															}
														>
															<i class="bx bx-log-out-circle gateOutSymbol"></i>
														</Button>
													)}
													{cellRenderHandler(cell) === "upload" && (
														<Button
															className="btn btn-sm btn-tbl"
															style={{ height: "35px", marginRight: "60px" }}
															onClick={() => uploadModalClickhandler(cell)}
															disabled={!allowToUpload}
														>
															<i class="bx bx-upload uploadSymbol"></i>
														</Button>
													)}
													{cellRenderHandler(cell) === "view" && (
														<Button
															className="btn btn-sm btn-tbl"
															style={{ height: "35px", marginRight: "50px" }}
															onClick={() => viewModalClickhandler(cell)}
															// disabled={!cell.row.original.InvoicePackingDoc}
														>
															<i
																class="bx bx-right-top-arrow-circle"
																style={{ transform: "scale(2)" }}
															></i>
														</Button>
													)}
												</div>
											</td>
										);
									})}
								</tr>
							);
						})}
					</tbody>
				</table>
			</div>
			{/* <MainTablePagination
        nextPage={nextPage}
        previousPage={previousPage}
        canNextPage={canNextPage}
        pageIndex={pageIndex}
        pageOptions={pageOptions}
        pageSize={pageSize}
        canPreviousPage={canPreviousPage}
        setPageSize={setPageSize}
      /> */}
			<MainTablePaginationAdv
				nextPage={nextPage}
				previousPage={previousPage}
				canNextPage={canNextPage}
				pageIndex={pageIndex}
				pageOptions={pageOptions}
				pageSize={pageSize}
				canPreviousPage={canPreviousPage}
				setPageSize={setPageSize}
				gotoPage={gotoPage}
				pageCount={pageCount}
			/>
			{showUploadModal && (
				<InvoicePackagingUploadModal
					show={showUploadModal}
					hide={() => setShowUploadModal(null)}
				/>
			)}
			{showViewModal && (
				<InvoicePackagingPDFViewer
					show={showViewModal}
					hide={() => setShowViewModal(null)}
					date={date}
					type="departureScreen"
				/>
			)}
		</>
	);
}

export default DepartureReportTable;
